export const API_KEY_METADATA_KEY = 'apiKey'
export const CONNECTS_API_SLUG = 'connects-api'
export const NEXUS_API_SLUG = 'nexus-api'
// TODO (SPD-554): update these values with the actual project slugs from stoplight
export const CONNECTS_API_V2_SLUG = 'connects-api-v2'
export const NEXUS_API_V2_SLUG = 'nexus-api-v2'
export const PAYMENTS_API_V2_SLUG = 'payments-api-v2'
